import React from "react";
import { Link } from "react-router-dom";
import ProjectCard from "../common/ProjectCard";
import Reveal, { RevealGroup, RevealItem, SplitTitle } from "../ui/Reveal";
import DirArrow from "../ui/DirArrow";
import projects from "../../data/projects.json";
import useLang from "../../hooks/useLang";

// Our Work: project cards and a link to all projects.
const OurWorkSection = () => {
  const { t } = useLang();

  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="container-site">
        <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
          <div>
            <span className="eyebrow text-rose-dark">{t("ourWork.badge")}</span>
            <SplitTitle text={t("ourWork.title")} className="h-section text-ink mt-4" />
            <p className="lead text-zinc-500 mt-4 max-w-xl">{t("ourWork.description")}</p>
          </div>
          <Link to="/projects" className="link-arrow group text-rose-dark hover:text-rose">
            {t("ourWork.viewAll")} <DirArrow nudge size={14} />
          </Link>
        </Reveal>
        <RevealGroup className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.slice(0, 3).map((project, i) => (
            <RevealItem key={project.id}>
              <ProjectCard project={project} index={i} />
            </RevealItem>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
};

export default OurWorkSection;
